/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert, InputGroup,
  NavItem, NavLink, Nav, TabPane, TabContent,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';

function InventoryForm(props) {
  const {
    actionUrl,
    entity,
    t,
    user,
  } = props;

  const [, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [boxes, setBoxes] = useState([]);
  const isAdmin = Array.isArray(user?.roles)
    && user.roles.some((role) => ['Admin', 'Super Admin'].includes(role));

  useEffect(() => {
    let mounted = true;

    get('/api/inventory/boxes')
      .then((results) => {
        if (mounted) setBoxes(results);
      })
      .catch(() => {
        if (mounted) setBoxes([]);
      });

    return () => {
      mounted = false;
    };
  }, []);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(t(`Item ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    part_number: Yup.string().required(t('Part Number is required')),
    consignment_fee: Yup.number().nullable(),
    manufacturer: Yup.string().required(t('Part Manufacturer is required')),
    ship_weight: Yup.number().required(t('Ship Weight is required')),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, setFieldValue, values,
        }) => (
          <Form className="mt-3" id="ItemEditForm" autoComplete="off">
            {Object.entries(errors).length > 0 && (
              <Alert color="danger">{t('Form contains errors')}</Alert>
            )}
            <Row>
              <Col md="3">
                <Nav pills className="flex-column">
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '1',
                      })}
                      onClick={() => {
                        setActiveTab('1');
                      }}
                    >
                      {props.t('General')}
                    </NavLink>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '2',
                      })}
                      onClick={() => {
                        setActiveTab('2');
                      }}
                    >
                      {props.t('Shipping')}
                    </NavLink>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '3',
                      })}
                      onClick={() => {
                        setActiveTab('3');
                      }}
                    >
                      {props.t('Business')}
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col md="9">
                <TabContent
                  activeTab={activeTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="sj_sku"
                            className="col-form-label"
                          >
                            {props.t('ShopJimmy Reference')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.sj_sku && touched.sj_sku ? 'is-invalid' : '')}`}
                            id="sj_sku"
                            name="sj_sku"
                            onChange={(e) => {
                              setFieldValue('sj_sku', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="sj_sku"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>

                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="stock_id"
                            className="col-form-label"
                          >
                            {props.t('Stock ID')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.stock_id && touched.stock_id ? 'is-invalid' : '')}`}
                            id="stock_id"
                            name="stock_id"
                            onChange={(e) => {
                              setFieldValue('stock_id', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="stock_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-3">
                      <Label
                        for="manufacturer"
                        className="col-form-label"
                      >
                        {props.t('Part Manufacturer')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control ${(errors.manufacturer && touched.manufacturer ? 'is-invalid' : '')}`}
                        id="manufacturer"
                        name="manufacturer"
                      />
                      <ErrorMessage
                        name="manufacturer"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="part_number"
                            className="col-form-label"
                          >
                            {props.t('Part Number')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.part_number && touched.part_number ? 'is-invalid' : '')}`}
                            id="part_number"
                            name="part_number"
                            onChange={(e) => {
                              setFieldValue('part_number', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="part_number"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm="6">
                        <div className="form-check mb-3">
                          <Field
                            type="checkbox"
                            name="has_core"
                            className="form-check-input"
                            id="has_core"
                            onChange={(e) => {
                              setFieldValue('has_core', e.target.checked);
                            }}
                          />
                          <Label className="form-check-label" for="has_core">
                            {t('Has Reusable Core')}
                          </Label>
                        </div>
                      </Col>
                    </Row>

                    <div className="mb-3">
                      <Label
                        for="image_url"
                        className="col-form-label"
                      >
                        {props.t('Image URL')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control ${(errors.image_url && touched.image_url ? 'is-invalid' : '')}`}
                        id="iamge_url"
                        name="image_url"
                        onChange={(e) => {
                          setFieldValue('image_url', e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="image_url"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mb-3">
                      <Label
                        for="notes"
                        className="col-form-label"
                      >
                        {props.t('Notes')}
                      </Label>
                      <Field
                        type="text"
                        as="textarea"
                        className={`form-control ${(errors.notes && touched.notes ? 'is-invalid' : '')}`}
                        id="notes"
                        name="notes"
                        onChange={(e) => {
                          setFieldValue('notes', e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="notes"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </TabPane>

                  <TabPane tabId="2">
                    <div className="mb-3">
                      <Label for="box_id" className="col-form-label">
                        {props.t('Box Size')}
                      </Label>
                      <Field
                        as="select"
                        className="form-select"
                        id="box_id"
                        name="box_id"
                        disabled={!isAdmin}
                        value={isAdmin && !values.box_id_locked ? '' : (values.box_id || '')}
                        onChange={(e) => {
                          const boxId = e.target.value === '' ? null : Number(e.target.value);
                          setFieldValue('box_id', boxId);
                          setFieldValue('box_id_locked', boxId !== null);
                        }}
                      >
                        <option value="">
                          {values.box_id && !values.box_id_locked
                            ? `${props.t('Automatic')} (${boxes.find((box) => Number(box.id) === Number(values.box_id))?.box_name || '-'})`
                            : props.t('Automatic')}
                        </option>
                        {boxes.map((box) => (
                          <option key={box.id} value={box.id}>
                            {`${box.box_name}${box.unit_price == null ? '' : ` — $${Number(box.unit_price).toFixed(2)}`}`}
                          </option>
                        ))}
                      </Field>
                      {!isAdmin && (
                        <small className="text-muted">{props.t('Only Admin users can change the box size.')}</small>
                      )}
                    </div>

                    <div className="mb-3">
                      <Label
                        for="ship_desc"
                        className="col-form-label"
                      >
                        {props.t('Customs Description')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control ${(errors.ship_desc && touched.ship_desc ? 'is-invalid' : '')}`}
                        id="ship_desc"
                        name="ship_desc"
                      />
                      <ErrorMessage
                        name="ship_desc"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="ship_weight"
                            className="col-form-label"
                          >
                            {props.t('Default Ship Weight')}
                          </Label>
                          <InputGroup>
                            <Field
                              type="number"
                              className={`form-control ${(errors.ship_weight && touched.ship_weight ? 'is-invalid' : '')}`}
                              id="ship_weight"
                              name="ship_weight"
                            />
                            <span className="input-group-text">LBS</span>
                          </InputGroup>
                          <ErrorMessage
                            name="ship_weight"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="ship_dims"
                            className="col-form-label"
                          >
                            {props.t('Default Ship Dimensions')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.ship_dims && touched.ship_dims ? 'is-invalid' : '')}`}
                            id="ship_dims"
                            name="ship_dims"
                          />
                          <ErrorMessage
                            name="ship_dims"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="ship_hts"
                            className="col-form-label"
                          >
                            {props.t('HTS Code')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.ship_hts && touched.ship_hts ? 'is-invalid' : '')}`}
                            id="ship_hts"
                            name="ship_hts"
                          />
                          <ErrorMessage
                            name="ship_hts"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="3">
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="cos_fee"
                            className="col-form-label"
                          >
                            {props.t('Consignment Fee')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.consignment_fee && touched.consignment_fee ? 'is-invalid' : '')}`}
                            id="cos_fee"
                            name="consignment_fee"
                            onChange={(e) => {
                              setFieldValue('consignment_fee', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="consignment_fee"
                            component="div"
                            className="invalid-feedback"
                          />
                          <small className="text-muted">
                            {props.t('Consignment Fee is what you receive when the item is sold.')}
                          </small>
                        </div>
                      </Col>

                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="handling_fee"
                            className="col-form-label"
                          >
                            {props.t('Additional Handling Fee')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.handling_fee && touched.handling_fee ? 'is-invalid' : '')}`}
                            id="handling_fee"
                            name="handling_fee"
                            onChange={(e) => {
                              setFieldValue('handling_fee', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="handling_fee"
                            component="div"
                            className="invalid-feedback"
                          />
                          <small className="text-muted">
                            {props.t('Handling Fee is in addition to the consignment fee.')}
                          </small>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="lead_time"
                            className="col-form-label"
                          >
                            {props.t('Lead Time')}
                          </Label>
                          <Field
                            type="number"
                            className={`form-control ${(errors.lead_time && touched.lead_time ? 'is-invalid' : '')}`}
                            id="lead_time"
                            name="lead_time"
                            onChange={(e) => {
                              setFieldValue('lead_time', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="lead_time"
                            component="div"
                            className="invalid-feedback"
                          />
                          <small className="text-muted">
                            {props.t('Number of days until item ships out.')}
                          </small>
                        </div>
                      </Col>

                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="lead_time"
                            className="col-form-label"
                          >
                            {props.t('Warranty Period')}
                          </Label>
                          <Field
                            type="number"
                            className={`form-control ${(errors.warranty && touched.warranty ? 'is-invalid' : '')}`}
                            id="warranty"
                            name="warranty"
                            onChange={(e) => {
                              setFieldValue('warranty', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="warranty"
                            component="div"
                            className="invalid-feedback"
                          />
                          <small className="text-muted">
                            {props.t('Days from purchase until warranty expires.')}
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

InventoryForm.defaultProps = {
  entity: {
    ship_weight: 1,
    part_number: '',
    manufacturer: '',
    variant_label: '',
    has_core: false,
  },
  onSuccess: () => {},
  user: { roles: [] },
};

InventoryForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
  user: PropTypes.object,
};

export default connect((state) => ({
  user: state.Login.user,
}), {})(withTranslation()(InventoryForm));
